export default __webpack_public_path__ + "static/media/03.c100f3f7.png";